/* Lorelia Startseite · Einstiegs-Varianten: Kurzfilm (Variante 1) und Lupe der Galerie (Variante 3).
   Ohne JS: erstes Bild bzw. alle Kacheln sichtbar. Bewegung nur bei prefers-reduced-motion: no-preference. */
(function () {
  'use strict';
  if (window.LR26V) return;
  window.LR26V = { version: 1 };
  var D = document;
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qsa = function (s, el) { return Array.prototype.slice.call((el || D).querySelectorAll(s)); };
  var IC_PLAY = '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true" focusable="false"><path d="M3 1.5v9l7.5-4.5z"/></svg>';
  var UEBERGANG = { schnitt: 0, wisch: 800, blende: 750, iris: 1000 };

  /* ---------- Variante 1: Kurzfilm ---------- */
  function film(b) {
    var sek = b.closest('.lr26-film');
    var shots = qsa('[data-shot]', b), n = shots.length;
    if (!n) return;
    var kap = qsa('[data-kapitel]', sek), balken = kap.map(function (k) { return k.querySelector('b'); });
    var pause = b.querySelector('[data-pause]'), IC_PAUSE = pause ? pause.innerHTML : '';
    var prod = sek.querySelector('[data-produkt]'), pArt = sek.querySelector('[data-p-art]'), pName = sek.querySelector('[data-p-name]');
    var idx = 0, t = 0, letzt = 0, raf = 0, aufr = 0;
    var lauf = !ruhig && n > 1, angehalten = false, bereit = false, sicht = true, ende = false;
    var dauer = function (f) { return parseInt(f.getAttribute('data-dauer'), 10) || 2400; };

    /* Fokuspunkt des Bildes auf eine Stelle der Bühne legen (object-position in px, kein Hochzoomen) */
    function ausrichten(f, ziel) {
      var img = f.querySelector('img'); if (!img) return;
      var W = b.clientWidth, H = b.clientHeight;
      var w = img.naturalWidth || +img.getAttribute('width') || W, h = img.naturalHeight || +img.getAttribute('height') || H;
      var s = Math.max(W / w, H / h), rw = w * s, rh = h * s;
      var fx = parseFloat(f.getAttribute('data-fx')), fy = parseFloat(f.getAttribute('data-fy'));
      if (isNaN(fx)) fx = .5; if (isNaN(fy)) fy = .45;
      var zx = ziel ? ziel[0] * W : W * .5, zy = ziel ? ziel[1] * H : H * .45;
      var ox = Math.min(Math.max(fx * rw - zx, 0), rw - W), oy = Math.min(Math.max(fy * rh - zy, 0), rh - H);
      img.style.objectPosition = (-ox).toFixed(1) + 'px ' + (-oy).toFixed(1) + 'px';
      f._p = [(fx * rw - ox) / W, (fy * rh - oy) / H];
      f.style.setProperty('--fx', (f._p[0] * 100).toFixed(2) + '%');
      f.style.setProperty('--fy', (f._p[1] * 100).toFixed(2) + '%');
    }
    function lade(k) {
      var img = shots[k] && shots[k].querySelector('img');
      if (!img) return;
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    }
    function bewegung(f) {
      f.classList.remove('ist-lauf'); void f.offsetWidth;
      f.style.setProperty('--d', dauer(f) + 'ms');
      if (!ruhig) f.classList.add('ist-lauf');
    }
    function balkenSetzen(p, alle) {
      balken.forEach(function (x, j) { if (x) x.style.setProperty('--f', alle ? 1 : j < idx ? 1 : j === idx ? p.toFixed(3) : 0); });
    }
    function knopf() {
      if (!pause) return;
      var an = lauf && !angehalten;
      pause.innerHTML = an ? IC_PAUSE : IC_PLAY;
      pause.setAttribute('aria-label', an ? 'Film anhalten' : (ende ? 'Film noch einmal abspielen' : 'Film abspielen'));
      sek.classList.toggle('ist-pause', angehalten);
    }
    function produkt(f) {
      if (!prod) return;
      if (pArt) pArt.textContent = f.getAttribute('data-art') || '';
      if (pName) pName.textContent = f.getAttribute('data-name') || '';
      var z = f.getAttribute('data-ziel'); if (z) prod.setAttribute('href', z);
    }
    function zeige(k, art, still) {
      if (k === idx) return;
      clearTimeout(aufr);
      var alt = shots[idx], neu = shots[k];
      shots.forEach(function (f) { if (f !== alt && f !== neu) { f.hidden = true; f.classList.remove('ist-neu', 'ist-los', 'ist-lauf', 'ist-alt'); } });
      art = ruhig ? 'schnitt' : (art || neu.getAttribute('data-ein') || 'blende');
      var anschluss = (art === 'schnitt' || art === 'iris') && alt._p ? alt._p : null;
      lade(k);
      neu.hidden = false;
      ausrichten(neu, anschluss);
      if (art === 'iris' && alt._p) {
        neu.style.setProperty('--ix', (alt._p[0] * 100).toFixed(2) + '%');
        neu.style.setProperty('--iy', (alt._p[1] * 100).toFixed(2) + '%');
      }
      alt.classList.remove('ist-neu', 'ist-los'); alt.classList.add('ist-alt');
      neu.classList.remove('ist-alt', 'ist-los'); neu.setAttribute('data-uebergang', art); neu.classList.add('ist-neu');
      void neu.offsetWidth; neu.classList.add('ist-los');
      if (still) neu.classList.remove('ist-lauf'); else bewegung(neu);
      aufr = setTimeout(function () {
        alt.hidden = true; alt.classList.remove('ist-alt', 'ist-lauf');
        neu.classList.remove('ist-neu', 'ist-los');
      }, (UEBERGANG[art] || 0) + 80);
      kap.forEach(function (x, j) { if (j === k) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
      idx = k; t = 0;
      produkt(neu);
      lade((k + 1) % n);
    }
    function aktiv() { return lauf && !angehalten && bereit && sicht && !D.hidden; }
    function schritt(ts) {
      raf = 0;
      if (!aktiv()) { letzt = 0; return; }
      if (!letzt) letzt = ts;
      t += Math.min(ts - letzt, 100); letzt = ts;
      var d = dauer(shots[idx]), p = Math.min(t / d, 1);
      balkenSetzen(p);
      if (p >= 1) {
        if (idx === n - 1) {            /* Ende: ruhig zurück auf die Totale, dann Stillstand */
          ende = true; lauf = false;
          zeige(0, 'blende', true); balkenSetzen(1, true); knopf();
          return;
        }
        var nx = idx + 1, img = shots[nx].querySelector('img');
        if (!(img && !img.complete && t < d + 3000)) zeige(nx);
      }
      raf = requestAnimationFrame(schritt);
    }
    function starten() { if (!raf && aktiv()) { letzt = 0; raf = requestAnimationFrame(schritt); } }

    shots.forEach(function (f) { ausrichten(f); });
    produkt(shots[0]);
    knopf();
    balkenSetzen(0);
    if (n < 2) return;
    if (pause) pause.addEventListener('click', function () {
      if (ende || !lauf) {                /* neu starten bzw. fortsetzen */
        if (ende) { ende = false; zeige(0, 'blende'); if (idx === 0) bewegung(shots[0]); t = 0; balkenSetzen(0); }
        lauf = true; angehalten = false;
      } else {
        angehalten = !angehalten;
      }
      knopf(); starten();
    });
    kap.forEach(function (x, j) {
      x.addEventListener('click', function () {
        lauf = false; angehalten = false; ende = false; knopf();
        if (j === idx) { bewegung(shots[j]); return; }
        zeige(j, 'blende'); balkenSetzen(1);
      });
    });
    b.addEventListener('focusin', function (e) { if (e.target !== pause && lauf) { lauf = false; knopf(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { sicht = e[0].isIntersecting; starten(); }, { threshold: .35 }).observe(b);
    D.addEventListener('visibilitychange', starten);
    var rz = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(rz);
      rz = requestAnimationFrame(function () { shots.forEach(function (f, j) { if (j !== idx) ausrichten(f); }); ausrichten(shots[idx]); });
    }, { passive: true });
    shots.forEach(function (f) { var img = f.querySelector('img'); if (img) img.addEventListener('load', function () { if (f === shots[idx]) ausrichten(f); }); });
    function los() {
      setTimeout(function () {
        bereit = true; lade(1);
        if (lauf) bewegung(shots[0]);
        starten();
      }, 500);
    }
    if (D.readyState === 'complete') los(); else window.addEventListener('load', los, { once: true });
  }

  /* ---------- Variante 3: Lupe über dem Poster ---------- */
  function lupe(k) {
    var img = k.querySelector('img'), L = k.querySelector('.lr26-lupe');
    if (!img || !L || ruhig) return;
    var rect = (k.getAttribute('data-rect') || '').split(',').map(Number);
    var pfad = (k.getAttribute('data-pfad') || '').split(';').map(function (p) { return p.split(',').map(Number); });
    if (rect.length !== 4 || pfad.length < 2) return;
    var Z = 2.8, gelaufen = false;
    function lage() {
      var W = k.clientWidth, H = k.clientHeight;
      var w = img.naturalWidth || +img.getAttribute('width'), h = img.naturalHeight || +img.getAttribute('height');
      var s = Math.max(W / w, H / h), rw = w * s, rh = h * s;
      var op = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
      var pct = function (v, frei) { return v.indexOf('%') > -1 ? parseFloat(v) / 100 * frei : parseFloat(v) || 0; };
      var ox = pct(op[0], W - rw), oy = pct(op[1] || '50%', H - rh);
      var x0 = ox + rect[0] * rw, y0 = oy + rect[1] * rh, pw = (rect[2] - rect[0]) * rw, ph = (rect[3] - rect[1]) * rh;
      var d = Math.round(Math.min(W * .56, 150));
      return { x0: x0, y0: y0, pw: pw, ph: ph, d: d };
    }
    function stelle(g, u, v) {
      var cx = g.x0 + u * g.pw, cy = g.y0 + v * g.ph;
      L.style.transform = 'translate3d(' + (cx - g.d / 2).toFixed(1) + 'px,' + (cy - g.d / 2).toFixed(1) + 'px,0)';
      L.style.backgroundPosition = (-(u * g.pw * Z - g.d / 2)).toFixed(1) + 'px ' + (-(v * g.ph * Z - g.d / 2)).toFixed(1) + 'px';
    }
    function laufen() {
      if (gelaufen) return; gelaufen = true;
      var g = lage();
      L.style.setProperty('--ld', g.d + 'px');
      L.style.backgroundImage = 'url("' + k.getAttribute('data-lupe-bild') + '")';
      L.style.backgroundSize = (g.pw * Z).toFixed(1) + 'px ' + (g.ph * Z).toFixed(1) + 'px';
      stelle(g, pfad[0][0], pfad[0][1]);
      var bild = new Image();
      bild.onload = function () {
        L.classList.add('ist-an');
        var SEG = 1100, HALT = 700, t0 = 0, n = pfad.length - 1;
        var ease = function (x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
        requestAnimationFrame(function f(ts) {
          if (!t0) t0 = ts;
          var t = ts - t0, i = Math.floor(t / (SEG + HALT));
          if (i >= n) {
            stelle(g, pfad[n][0], pfad[n][1]);
            setTimeout(function () { L.classList.remove('ist-an'); L.style.transition = 'opacity .5s'; L.style.opacity = '0'; }, 1600);
            return;
          }
          var r = t - i * (SEG + HALT), q = ease(Math.min(1, r / SEG));
          var a = pfad[i], c = pfad[i + 1];
          stelle(g, a[0] + (c[0] - a[0]) * q, a[1] + (c[1] - a[1]) * q);
          requestAnimationFrame(f);
        });
      };
      bild.src = k.getAttribute('data-lupe-bild');
    }
    /* startet, sobald die Kachel sichtbar ist und die Collage steht */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { io.disconnect(); setTimeout(laufen, 1300); }
      }, { threshold: .6 });
      io.observe(k);
    } else setTimeout(laufen, 1500);
  }


  /* ---------- Einstieg „Serie“: Poster an derselben Wand, danach Ketten ---------- */
  function serie(b) {
    var sek = b.closest('.lr26-serie');
    var fP = b.querySelector('[data-feld="poster"]'), fS = b.querySelector('[data-feld="schmuck"]');
    var P = qsa('[data-bild]', fP), S = fS ? qsa('[data-bild]', fS) : [];
    if (!P.length) return;
    var pause = b.querySelector('[data-pause]'), IC_PAUSE = pause ? pause.innerHTML : '';
    var balken = qsa('[data-fort] b', b);
    var imbild = b.querySelector('[data-imbild]'), imName = b.querySelector('[data-imbild-name]');
    var breit = window.matchMedia('(min-width: 990px)');
    /* Handy: ein Wechsel alle 1,5 s (Luca 30.09.2026), Desktop etwas ruhiger */
    var HALT = 1050, HALT_S = 1050, BLENDE = 450, HALT_D = 1500, HALT_SD = 1700, BLENDE_D = 600, RUNDEN = 3, WARTEN = 3000;
    var blende = function () { return breit.matches ? BLENDE_D : BLENDE; };
    var lauf = !ruhig, angehalten = false, bereit = false, sicht = true, hover = false;
    var iP = 0, iS = 0, phase = 'poster', t = 0, tS = -1500, letzt = 0, raf = 0, runde = 0;

    function img(f) { return f && f.querySelector('img'); }
    function lade(f) { var i = img(f); if (!i) return; if (i.loading === 'lazy') i.loading = 'eager'; if (i.decode) i.decode().catch(function () {}); }
    function fertig(f) { var i = img(f); return !i || (i.complete && i.naturalWidth > 0); }
    function text(f, feld) {
      var n = ((f.getAttribute('data-art') || '') + ' ' + (f.getAttribute('data-name') || '')).trim(), z = f.getAttribute('data-ziel') || '#';
      var chip = feld && feld.querySelector('[data-chip]');
      if (chip) { chip.setAttribute('href', z); var c = chip.querySelector('[data-chip-name]'); if (c) c.textContent = n; }
      if (imName) imName.textContent = n;
      if (imbild) imbild.setAttribute('href', z);
    }
    function wechsel(liste, von, nach) {
      if (von === nach) return;
      var alt = liste[von], neu = liste[nach];
      liste.forEach(function (f) { if (f !== alt && f !== neu) { f.hidden = true; f.classList.remove('ist-neu', 'ist-auf', 'ist-alt'); } });
      neu.hidden = false;
      alt.classList.remove('ist-neu', 'ist-auf'); alt.classList.add('ist-alt');
      if (ruhig) { alt.hidden = true; alt.classList.remove('ist-alt'); return; }
      neu.classList.add('ist-neu'); void neu.offsetWidth; neu.classList.add('ist-auf');
      setTimeout(function () { if (neu.classList.contains('ist-auf')) { alt.hidden = true; alt.classList.remove('ist-alt'); neu.classList.remove('ist-neu', 'ist-auf'); } }, blende() + 60);
    }
    /* Handy: nächstes Bild der Folge (erst alle Poster, dann alle Ketten) */
    function naechstes() {
      if (phase === 'poster') return iP < P.length - 1 ? P[iP + 1] : (S.length ? S[0] : P[0]);
      return iS < S.length - 1 ? S[iS + 1] : P[0];
    }
    function weiter() {
      if (phase === 'poster') {
        if (iP < P.length - 1) { wechsel(P, iP, iP + 1); iP++; text(P[iP], fP); }
        else if (S.length) { phase = 'schmuck'; iS = 0; S.forEach(function (f, j) { f.hidden = j !== 0; f.classList.remove('ist-neu', 'ist-auf', 'ist-alt'); }); sek.classList.add('ist-schmuck'); text(S[0], fS); }
        else { runde++; wechsel(P, iP, 0); iP = 0; text(P[0], fP); }
      } else if (iS < S.length - 1) { wechsel(S, iS, iS + 1); iS++; text(S[iS], fS); }
      else {
        runde++; phase = 'poster';
        P.forEach(function (f, j) { f.hidden = j !== 0; f.classList.remove('ist-neu', 'ist-auf', 'ist-alt'); }); iP = 0;
        sek.classList.remove('ist-schmuck'); text(P[0], fP);
      }
      lade(naechstes());
      if (runde >= RUNDEN) { lauf = false; knopf(); }
    }
    var REIHE = ['poster', 'schmuck', 'foto'], gruppen = qsa('[data-fort] i', b);
    function fortschritt(p) {                       /* drei Abschnitte: Poster, Schmuck, Fotogeschenke */
      if (breit.matches || !gruppen.length) return;
      var jetzt = phase === 'poster' ? P[iP] : S[iS], g = jetzt.getAttribute('data-gruppe') || phase;
      var liste = (phase === 'poster' ? P : S).filter(function (f) { return (f.getAttribute('data-gruppe') || phase) === g; });
      var anteil = (liste.indexOf(jetzt) + p) / Math.max(1, liste.length);
      gruppen.forEach(function (i) {
        var r = REIHE.indexOf(i.getAttribute('data-gruppe')) - REIHE.indexOf(g), x = i.querySelector('b');
        if (x) x.style.setProperty('--f', r < 0 ? 1 : r === 0 ? anteil.toFixed(3) : 0);
      });
    }
    function knopf() {
      if (!pause) return;
      var an = lauf && !angehalten;
      pause.innerHTML = an ? IC_PAUSE : '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true" focusable="false"><path d="M3 1.5v9l7.5-4.5z"/></svg>';
      pause.setAttribute('aria-label', an ? 'Wechsel anhalten' : 'Wechsel abspielen');
    }
    function aktiv() { return lauf && !angehalten && bereit && sicht && !hover && !D.hidden; }
    function schritt(ts) {
      raf = 0;
      if (!aktiv()) { letzt = 0; return; }
      if (!letzt) letzt = ts;
      var dt = Math.min(ts - letzt, 100); letzt = ts;
      if (breit.matches) {                          /* Desktop: zwei Hälften, versetzt */
        t += dt; tS += dt;
        var nP = (iP + 1) % P.length;
        if (t >= HALT_D + BLENDE_D && (fertig(P[nP]) || t > HALT_D + BLENDE_D + WARTEN)) {
          t = 0; wechsel(P, iP, nP); iP = nP; text(P[iP], fP); lade(P[(iP + 1) % P.length]); if (nP === 0) runde++;
        }
        var nS = (iS + 1) % S.length;
        if (S.length > 1 && tS >= HALT_SD + BLENDE_D && (fertig(S[nS]) || tS > HALT_SD + BLENDE_D + WARTEN)) {
          tS = 0; wechsel(S, iS, nS); iS = nS; text(S[iS], fS); lade(S[(iS + 1) % S.length]);
        }
        if (runde >= RUNDEN) { lauf = false; knopf(); return; }
      } else {
        t += dt;
        var d = (phase === 'poster' ? HALT : HALT_S) + BLENDE;
        fortschritt(Math.min(t / d, 1));
        if (t >= d && (fertig(naechstes()) || t > d + WARTEN)) { t = 0; weiter(); if (!lauf) return; }
      }
      raf = requestAnimationFrame(schritt);
    }
    function starten() { if (!raf && aktiv()) { letzt = 0; raf = requestAnimationFrame(schritt); } }
    if (S.length) text(S[0], fS);
    text(P[0], fP);                                 /* zuletzt: das sichtbare Poster bestimmt die Zeile „Im Bild“ */
    if (breit.matches && S.length) { var ch = fS.querySelector('[data-chip-name]'); if (ch) ch.textContent = ((S[0].getAttribute('data-art') || '') + ' ' + (S[0].getAttribute('data-name') || '')).trim(); }
    knopf();
    if (P.length + S.length < 2) return;
    if (pause) pause.addEventListener('click', function () {
      if (!lauf) { lauf = true; angehalten = false; runde = 0; } else angehalten = !angehalten;
      knopf(); starten();
    });
    b.addEventListener('focusin', function (e) { if (e.target !== pause && lauf) { lauf = false; knopf(); } });
    if (window.matchMedia('(hover: hover)').matches) {
      b.addEventListener('mouseenter', function () { hover = true; });
      b.addEventListener('mouseleave', function () { hover = false; starten(); });
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { sicht = e[0].isIntersecting; starten(); }, { threshold: .35 }).observe(b);
    D.addEventListener('visibilitychange', starten);
    function los() { setTimeout(function () { bereit = true; sek.classList.add('ist-bereit'); lade(P[1] || S[0]); if (breit.matches) lade(S[1]); starten(); }, 250); }
    if (D.readyState === 'complete') los(); else window.addEventListener('load', los, { once: true });
  }

  function start(r) {
    r = r || D;
    qsa('[data-lr26-film]', r).forEach(film);
    qsa('[data-lupe]', r).forEach(lupe);
    qsa('[data-lr26-serie]', r).forEach(serie);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  D.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
